import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/style.css'
import appHelper from "./helpers/app_helper";

// Import for multiple languages
import VueI18n from 'vue-i18n';
import enMessage from './locale/en.json'
import viMessage from './locale/vi.json'

// Import for notification
import Notifications from 'vue-notification'

// Import for dialog
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// Import for bootstrap
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Import for validate
import { extend, localize, ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email, min, max, confirmed } from "vee-validate/dist/rules";
import viVeeValidate from "./locale/vee-validate/vi.json";
import enVeeValidate from "./locale/vee-validate/en.json";

// Import for vue-custom-scrollbar
import vueCustomScrollbar from 'vue-custom-scrollbar'
import "vue-custom-scrollbar/dist/vueScrollbar.css"

// Import custom components
import PanelLoading from "./components/PanelLoading";

Vue.config.productionTip = false

// Setup for multiple language
console.log("Setup i18n: STARTING...");
Vue.use(VueI18n);
let languageCode = store.getters.languageCode;
console.log(`UI languageCode: ${languageCode}`);

const i18n = new VueI18n({
    locale: languageCode,
    messages: {
        en: enMessage,
        vi: viMessage
    },
    fallbackLocale: languageCode
});

console.log("Setup i18n: DONE");

// Setup for notification
console.log("Setup vue-notification: STARTING...");
Vue.use(Notifications);
console.log("Setup vue-notification: DONE");

// Setup for dialog
console.log("Setup vue-sweetalert2: STARTING...");
Vue.use(VueSweetalert2);
console.log("Setup vue-sweetalert2: DONE");

// Setup for bootstrap-vue
console.log("Setup bootstrap-vue: STARTING...");
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
console.log("Setup bootstrap-vue: DONE");

// Setup for vee-validate
console.log("Setup vee-validate: STARTING...");
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

extend("required", required);
extend("email", email);
extend("min", min);
extend("max", max);
extend("confirmed", confirmed);

localize({
    'en': enVeeValidate,
    'vi': viVeeValidate
})

localize(languageCode)
console.log("Setup vee-validate: DONE");

console.log("Setup vue-custom-scrollbar: STARTING...");
Vue.component("vue-custom-scrollbar", vueCustomScrollbar);
console.log("Setup vue-custom-scrollbar: DONE");


Vue.component('PanelLoading', PanelLoading)

Vue.prototype.setTitle = function (title = "") {
    if (title === "")
        title = appHelper.settings.applicationName;
    else
        title = this.$t(title) + " - " + appHelper.settings.applicationName;

    document.title = title;
}

const app = new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
    created: async function () {
        //await appHelper.init();
        this.$i18n.locale = appHelper.getSetting("languageCode");
    }
}).$mount('#app')

export default app;
